var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"linkGraphPane",attrs:{"id":"linkGraphPane"}},[_c('G6SearchNode',{staticStyle:{"padding-left":"30%","padding-top":"2px"}}),_c('div',{ref:"mountNode"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }